<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
 
  <div id="data-list-thumb-view" class="data-list-container">
    <Info ref="InfoEquipments"></Info>
    <TableListOrders path='equipamentos'></TableListOrders>
  </div>
</template>

<script>
import TableListOrders from "../tableListOrders/listOrders";
import Info from "../infoOrdersAndStage/InfoEquipments";
export default {
  components: {
    TableListOrders,
    Info,
  },
  data() {
    return {
    };
  },
  computed: {
    
  },
  methods: {
 
  },
  async created() {
    let payload = {
      loading: this.$vs.loading,
      type: "notCompleted",
      userGroup: this.$store.state.user.userGroup,
    };
   
    await this.$store.dispatch("equipments/fetchEquipmentOrder", payload);
    this.$refs.InfoEquipments.calculateOrders(this.$store.state.equipments.equipmentOrders, 'success');
    this.$refs.InfoEquipments.showPercentageStage(this.$store.state.equipments.equipmentOrders,'success');
    
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
